import {
    THEME,
    THEME_SUCCESS,
    THEME_ERROR
} from "../constants/themeConstants";


const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function themeReducer(state = initialState, action) {
    switch (action.type) {
        case THEME:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': ''

            });
        case THEME_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case THEME_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'themeData': action.data.icons

            });
        // case ADD_THEME:
        //     return Object.assign({}, state, {
        //         'loading': true,
        //         'success': false,
        //         'error': ''
        //     });
        // case ADD_THEME_ERROR:
        //     return Object.assign({}, state, {
        //         'loading': false,
        //         'success': false,
        //         'error': action
        //     });
        // case ADD_THEME_SUCCESS:
        //     let addThemeData = state.themeData? [...state.themeData] : []
        //     addThemeData.push(action.data);

        //     return Object.assign({}, state, {
        //         'loading': false,
        //         'success': true,
        //         'error': '',
        //         'themeData': addThemeData
        //     }); 
        // case UPDATE_THEME:
        //     return Object.assign({}, state, {
        //         'loading': true,
        //         'success': false,
        //         'error': ''
        //     });
        // case UPDATE_THEME_ERROR:
        //     return Object.assign({}, state, {
        //         'loading': false,
        //         'success': false,
        //         'error': action
        //     });
        // case UPDATE_THEME_SUCCESS:

        //     let updThemeData = state.themeData? state.themeData: []

        //     updThemeData = updThemeData.map((item) => {return item._id === action.data._id?  action.data:  item});

        //     return Object.assign({}, state, {
        //         'loading': false,
        //         'success': true,
        //         'error': '',
        //         'themeData': updThemeData
        //     });   
        // case DELETE_THEME:
        //     return Object.assign({}, state, {
        //         'loading': true,
        //         'success': false,
        //         'error': ''
        //     });
        // case DELETE_THEME_ERROR:
        //     return Object.assign({}, state, {
        //         'loading': false,
        //         'success': false,
        //         'error': action
        //     });
        // case DELETE_THEME_SUCCESS:
        //     const deleteArray =  state.themeData.filter(item => item._id !== action.data);
        //     return Object.assign({}, state, {
        //         'loading': false,
        //         'success': true,
        //         'error': '',
        //         'themeData': deleteArray
        //     }); 
        default:
            return state;
    }
};

export default themeReducer